import type { DecisionEngineDestinationUI } from "./definition";

export const cordialUI: DecisionEngineDestinationUI = {
  campaignSetup: "resource",
  resourceName: "automation template",
  channelDescription: "Cordial",
  getReferenceString: (s) => `{$extVars.${s}}`,
  isInactive: () => false,
  isPreviewSupported: true,
  getTemplateResourceType: () => "email-template",
  getResourceType: () => "automation-template",
  getEmailPreviewMethod: "preview",
  isTestSendSupported: true,
};
